export default __webpack_public_path__ + "static/Van-DriverSide-338e2d74ecad644fe1a08cb676ac6894.png";